// @ts-nocheck
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('vue:error', (error) => {
    nuxtApp.$toast.error(error.message);
    console.error(error);
  });
});
